﻿(function () {
  const STYLE_ID = "lb-quickadd-fix-style";
  const BUTTON_CLASS = "lb-quickadd-fix-btn";
  const TOAST_ID = "lb-cart-feedback-toast";
  const PRODUCT_PATH_REGEX = /\/products\/([^/?#]+)/i;
  const LB_PROMO_CAPTION_NORMALIZER = "lb-promo-caption-normalized";
  const productCache = new Map();
  let scanTimer = null;
  let toastTimer = null;

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = `
      .lb-cart-btn,
      .product-action-btn.cart-btn,
      .single-product-add-button,
      .${BUTTON_CLASS} {
        background: rgba(17, 24, 39, .92) !important;
        color: #fff !important;
        border-color: rgba(255, 255, 255, .28) !important;
      }

      .lb-cart-btn svg,
      .product-action-btn.cart-btn svg,
      .single-product-add-button svg,
      .${BUTTON_CLASS} svg {
        stroke: currentColor !important;
        color: inherit !important;
      }

      .lb-cart-btn.is-added,
      .lb-cart-btn[data-added="true"],
      .product-action-btn.cart-btn.is-added,
      .product-action-btn.cart-btn[data-added="true"],
      .single-product-add-button.is-added,
      .single-product-add-button[data-added="true"],
      .${BUTTON_CLASS}.is-added {
        background: #15803d !important;
        color: #fff !important;
        opacity: 1 !important;
      }

      .lb-cart-btn.is-loading,
      .product-action-btn.cart-btn.is-loading,
      .single-product-add-button.is-loading,
      .${BUTTON_CLASS}.is-loading {
        background: #111827 !important;
        color: #fff !important;
        opacity: .94 !important;
      }

      .${BUTTON_CLASS} {
        appearance: none;
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 20;
        width: 42px;
        height: 42px;
        padding: 0;
        border: 1px solid rgba(255,255,255,.28);
        border-radius: 50%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        box-shadow: 0 10px 25px rgba(17,24,39,.22);
        transition: transform .18s ease, background-color .18s ease, opacity .18s ease;
      }

      .${BUTTON_CLASS}:hover:not(:disabled) {
        transform: translateY(-2px) scale(1.03);
      }

      .${BUTTON_CLASS}:disabled {
        cursor: wait;
      }

      .${BUTTON_CLASS} svg {
        width: 18px;
        height: 18px;
        fill: none;
        stroke-width: 2;
        stroke-linecap: round;
        stroke-linejoin: round;
      }

      .${BUTTON_CLASS} .lb-quickadd-check,
      .${BUTTON_CLASS}.is-added .lb-quickadd-cart {
        display: none;
      }

      .${BUTTON_CLASS}.is-added .lb-quickadd-check {
        display: block;
      }

      .lb-media,
      .latest-media,
      .t4s-product-inner,
      .t4s-product-img,
      .product-card,
      .t4s-pr {
        position: relative;
      }

      .promotions-storefront-caption-wrap.${LB_PROMO_CAPTION_NORMALIZER} {
        display: flex !important;
        width: 100% !important;
        margin: 6px 0 8px !important;
        padding: 0 !important;
        line-height: 1 !important;
        clear: both !important;
      }

      .promotions-storefront-caption-wrap.${LB_PROMO_CAPTION_NORMALIZER} .promotions-storefront-caption {
        margin: 0 !important;
        min-height: 24px !important;
        padding: 6px 10px !important;
        font-size: 12px !important;
        line-height: 1 !important;
        white-space: nowrap !important;
      }

      .carousel-item .product-info > .promotions-storefront-caption-wrap.${LB_PROMO_CAPTION_NORMALIZER},
      .product-card .promotions-storefront-caption-wrap.${LB_PROMO_CAPTION_NORMALIZER},
      .cer-card .promotions-storefront-caption-wrap.${LB_PROMO_CAPTION_NORMALIZER},
      .outfit-product-info > .promotions-storefront-caption-wrap.${LB_PROMO_CAPTION_NORMALIZER} {
        justify-content: center !important;
        text-align: center !important;
      }

      .lb-tile .lb-body > .promotions-storefront-caption-wrap.${LB_PROMO_CAPTION_NORMALIZER} {
        justify-content: flex-start !important;
        text-align: left !important;
      }

      .outfit-product-info > .promotions-storefront-caption-wrap.${LB_PROMO_CAPTION_NORMALIZER} {
        margin: 4px 0 6px !important;
      }

      /* lb-promo-caption-stable-css: style original app badges without moving nodes. */
      .carousel-item .promotions-storefront-caption-wrap,
      .product-card .promotions-storefront-caption-wrap,
      .cer-card .promotions-storefront-caption-wrap,
      .outfit-product-info > .promotions-storefront-caption-wrap {
        display: flex !important;
        width: 100% !important;
        margin: 6px 0 8px !important;
        padding: 0 !important;
        clear: both !important;
        justify-content: center !important;
        text-align: center !important;
        transform: none !important;
        transition: none !important;
        animation: none !important;
      }

      .lb-tile .lb-body > .promotions-storefront-caption-wrap {
        display: flex !important;
        width: 100% !important;
        margin: 6px 0 8px !important;
        padding: 0 !important;
        clear: both !important;
        justify-content: flex-start !important;
        text-align: left !important;
        transform: none !important;
        transition: none !important;
        animation: none !important;
      }

      .carousel-item .promotions-storefront-caption-wrap .promotions-storefront-caption,
      .product-card .promotions-storefront-caption-wrap .promotions-storefront-caption,
      .cer-card .promotions-storefront-caption-wrap .promotions-storefront-caption,
      .outfit-product-info > .promotions-storefront-caption-wrap .promotions-storefront-caption,
      .lb-tile .lb-body > .promotions-storefront-caption-wrap .promotions-storefront-caption {
        margin: 0 !important;
        min-height: 24px !important;
        padding: 6px 10px !important;
        font-size: 12px !important;
        line-height: 1 !important;
        white-space: nowrap !important;
        transform: none !important;
        transition: none !important;
        animation: none !important;
      }

      #${TOAST_ID} {
        position: fixed;
        top: 92px;
        right: 18px;
        z-index: 2147483000;
        display: flex;
        align-items: center;
        gap: 10px;
        max-width: calc(100vw - 36px);
        min-height: 44px;
        padding: 11px 15px;
        border-radius: 8px;
        background: #111827;
        color: #fff;
        box-shadow: 0 16px 38px rgba(17, 24, 39, .26);
        font-size: 14px;
        line-height: 1.25;
        opacity: 0;
        pointer-events: none;
        transform: translateY(-8px);
        transition: opacity .18s ease, transform .18s ease;
      }

      #${TOAST_ID}.is-visible {
        opacity: 1;
        transform: translateY(0);
      }

      #${TOAST_ID} svg {
        width: 18px;
        height: 18px;
        flex: 0 0 auto;
        color: #86efac;
        stroke: currentColor;
        fill: none;
        stroke-width: 2.4;
        stroke-linecap: round;
        stroke-linejoin: round;
      }

      @media (max-width: 767px) {
        #${TOAST_ID} {
          top: auto;
          right: 12px;
          bottom: 18px;
          left: 12px;
          justify-content: center;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function getHandleFromHref(href) {
    const match = String(href || "").match(PRODUCT_PATH_REGEX);
    return match ? match[1] : "";
  }

  function closestProductCard(anchor) {
    return anchor.closest(
      ".lb-tile, .product-card, .t4s-product, .t4s-pr-grid, .t4s-product-wrapper, .carousel-item",
    );
  }

  function findMediaHost(card, anchor) {
    return (
      card.querySelector(".lb-media") ||
      card.querySelector(".latest-media") ||
      card.querySelector(".t4s-product-inner") ||
      card.querySelector(".t4s-product-img") ||
      anchor.closest(".lb-media, .latest-media, .t4s-product-inner, .t4s-product-img") ||
      card
    );
  }

  function hasQuickAdd(card) {
    return Boolean(
      card.querySelector(
        ".lb-cart-btn, .product-action-btn.cart-btn, .single-product-add-button, .t4s-pr-addtocart, [data-action-atc], form[action*='/cart/add'], ." +
          BUTTON_CLASS,
      ),
    );
  }

  function isNonProductTile(card) {
    return Boolean(
      card.closest("[class*='collection-card'], [class*='category-card'], .t4s-banner-item, .t4s-banner-inner"),
    );
  }

  function buttonHtml() {
    return `
      <svg class="lb-quickadd-cart" viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="9" cy="20" r="1.25"></circle>
        <circle cx="18" cy="20" r="1.25"></circle>
        <path d="M3 4h2l2.1 10.1a1 1 0 0 0 1 .8h9.9a1 1 0 0 0 1-.8L21 7H7"></path>
      </svg>
      <svg class="lb-quickadd-check" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M20 6L9 17l-5-5"></path>
      </svg>
    `;
  }

  function injectButton(card, anchor, handle) {
    if (!handle || hasQuickAdd(card) || isNonProductTile(card)) return;

    const media = findMediaHost(card, anchor);
    if (!media) return;

    const button = document.createElement("button");
    button.type = "button";
    button.className = BUTTON_CLASS;
    button.dataset.productHandle = handle;
    button.setAttribute("aria-label", "Aggiungi al carrello");
    button.innerHTML = buttonHtml();
    media.appendChild(button);
  }

  async function getAvailableVariantId(handle) {
    if (productCache.has(handle)) return productCache.get(handle);

    const response = await fetch(`/products/${handle}.js`, {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    });
    if (!response.ok) throw new Error(`Product ${handle} unavailable`);

    const product = await response.json();
    const variant = (product.variants || []).find((item) => item.available) || product.variants?.[0];
    const variantId = variant?.available ? variant.id : null;
    productCache.set(handle, variantId);
    return variantId;
  }

  async function addVariantToCart(variantId) {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    });
    if (!response.ok) throw new Error("Cart add failed");
    return response.json();
  }

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat("it-IT", {
        style: "currency",
        currency: "EUR",
      }).format((Number(cents) || 0) / 100);
    } catch {
      return `€${(((Number(cents) || 0) / 100).toFixed(2)).replace(".", ",")}`;
    }
  }

  function setNodeText(selector, value) {
    document.querySelectorAll(selector).forEach((node) => {
      node.textContent = value;
    });
  }

  function syncCartUi(cart) {
    if (!cart) return;

    const count = Number(cart.item_count) || 0;
    const countText = String(count);
    const totalText = formatMoney(cart.total_price);

    document.documentElement.classList.forEach((className) => {
      if (/^t4s-cart-count-\d+$/.test(className)) {
        document.documentElement.classList.remove(className);
      }
    });
    document.documentElement.classList.add(`t4s-cart-count-${count}`);

    document
      .querySelectorAll(
        [
          "[data-cart-count]",
          ".t4s-count-box",
          ".cart-count",
          ".cart__count",
          ".js-cart-count",
          ".header__cart-count",
          ".site-header__cart-count",
        ].join(","),
      )
      .forEach((node) => {
        node.textContent = countText;
        node.classList.toggle("t4s-op-0", count <= 0);
        node.classList.toggle("is-empty", count <= 0);
        node.setAttribute("aria-label", `${countText} prodotti nel carrello`);
      });

    setNodeText("[data-cart-tt-price], .t4s-h-cart__total", totalText);

    document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));
    document.dispatchEvent(new CustomEvent("theme:cart:change", { detail: { cart } }));
  }

  function refreshCartBadges() {
    return fetch("/cart.js", { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then((response) => (response.ok ? response.json() : null))
      .then((cart) => {
        syncCartUi(cart);
        return cart;
      })
      .catch(() => {});
  }

  function showCartToast(message) {
    let toast = document.getElementById(TOAST_ID);
    if (!toast) {
      toast = document.createElement("div");
      toast.id = TOAST_ID;
      toast.setAttribute("role", "status");
      toast.setAttribute("aria-live", "polite");
      toast.innerHTML = `
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M20 6L9 17l-5-5"></path>
        </svg>
        <span></span>
      `;
      document.body.appendChild(toast);
    }

    toast.querySelector("span").textContent = message;
    window.clearTimeout(toastTimer);
    toast.classList.add("is-visible");
    toastTimer = window.setTimeout(() => {
      toast.classList.remove("is-visible");
    }, 1900);
  }

  function isCartAddRequest(resource, config) {
    const url = typeof resource === "string" ? resource : resource?.url || "";
    const method = String(config?.method || resource?.method || "GET").toUpperCase();
    return method !== "GET" && /\/cart\/add(\.js)?(?:[?#]|$)/.test(url);
  }

  function installCartFetchHook() {
    if (!window.fetch || window.__lbQuickAddFetchHooked) return;

    const originalFetch = window.fetch.bind(window);
    window.__lbQuickAddFetchHooked = true;
    window.fetch = function patchedFetch(resource, config) {
      const isCartAdd = isCartAddRequest(resource, config);
      return originalFetch(resource, config).then((response) => {
        if (isCartAdd && response && response.ok) {
          window.setTimeout(() => {
            refreshCartBadges();
            showCartToast("Prodotto aggiunto al carrello");
          }, 80);
        }
        return response;
      });
    };
  }

  function showAdded(button) {
    button.classList.remove("is-loading");
    button.classList.add("is-added");
    button.dataset.added = "true";
    button.setAttribute("aria-label", "Aggiunto al carrello");
    window.setTimeout(() => {
      button.classList.remove("is-added");
      delete button.dataset.added;
      button.disabled = false;
      button.setAttribute("aria-label", "Aggiungi al carrello");
    }, 1800);
  }

  async function handleInjectedClick(event) {
    const button = event.target.closest(`.${BUTTON_CLASS}`);
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    if (button.disabled) return;
    button.disabled = true;
    button.classList.add("is-loading");

    try {
      const variantId = await getAvailableVariantId(button.dataset.productHandle);
      if (!variantId) throw new Error("No available variant");
      await addVariantToCart(variantId);
      showAdded(button);
      await refreshCartBadges();
      showCartToast("Prodotto aggiunto al carrello");
    } catch {
      button.classList.remove("is-loading");
      button.disabled = false;
    }
  }

  function normalizeExistingButtonState(event) {
    const button = event.target.closest(
      ".lb-cart-btn, .product-action-btn.cart-btn, .single-product-add-button",
    );
    if (!button) return;

    window.setTimeout(() => {
      if (button.classList.contains("is-added") || button.dataset.added === "true") {
        button.style.backgroundColor = "#15803d";
        button.style.color = "#fff";
        showCartToast("Prodotto aggiunto al carrello");
      }
    }, 120);

    [450, 1000, 1800].forEach((delay) => {
      window.setTimeout(refreshCartBadges, delay);
    });
  }

  function insertAfter(node, reference) {
    if (!node || !reference?.parentNode) return false;
    const next = reference.nextSibling;
    if (next === node) return true;
    reference.parentNode.insertBefore(node, next);
    return true;
  }

  function findPromoCaptionTitle(card) {
    if (card.matches(".outfit-product-item")) {
      return card.querySelector(".outfit-product-title");
    }
    if (card.matches(".carousel-item")) {
      return card.querySelector(".product-info h3, h3");
    }
    if (card.matches(".lb-tile")) {
      return card.querySelector(".lb-name");
    }
    if (card.matches(".product-card")) {
      return card.querySelector(".product-title, .latest-title, .product-name, h3, h2");
    }
    if (card.matches(".cer-card")) {
      return card.querySelector("h3");
    }
    return null;
  }

  function normalizePromotionCaptions() {
    document.querySelectorAll(".lb-promo-caption-clone").forEach((clone) => clone.remove());
    document.querySelectorAll(".promotions-storefront-caption-wrap").forEach((wrap) => {
      const caption = wrap.querySelector(".promotions-storefront-caption");
      if (!caption || !/buy\s*3\s*pay\s*2/i.test(caption.textContent || "")) return;
      wrap.classList.remove("lb-promo-caption-source-hidden");
      wrap.classList.add(LB_PROMO_CAPTION_NORMALIZER);
    });
  }

  function scan() {
    injectStyles();
    document.querySelectorAll('a[href*="/products/"]').forEach((anchor) => {
      const handle = getHandleFromHref(anchor.getAttribute("href"));
      const card = closestProductCard(anchor);
      if (!card) return;
      injectButton(card, anchor, handle);
    });
  }

  function scheduleScan() {
    window.clearTimeout(scanTimer);
    scanTimer = window.setTimeout(scan, 100);
  }

  installCartFetchHook();

  document.addEventListener("click", handleInjectedClick, true);
  document.addEventListener("click", normalizeExistingButtonState, true);
  document.addEventListener("DOMContentLoaded", scan);
  window.addEventListener("pageshow", scan);
  window.addEventListener("load", scan);

  if ("MutationObserver" in window) {
    new MutationObserver(scheduleScan).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  scan();
})();


